import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import moment from 'moment';
import numeral from 'numeral';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {fetchStatsPlayersValue} from '../../../../../../actions/entities/statistics/players';
import Filters from '../../../../../../components/Filters';
import FilterLeague from '../../../../../../components/Filters/League';
import FilterLocation from '../../../../../../components/Filters/Location';
import FilterPeriod from '../../../../../../components/Filters/Period';
import Loader from '../../../../../../components/Loader';
import './index.css';
import {getChampionships} from '../../../../../../actions/entities/championships';
import {getChampionshipId} from '../../../../../../helpers/championship';
import getAvailableFlagsButtons from '../../../../../../helpers/getAvailableFlagsButtons';

class StatsPlayersValueWidget extends React.Component {
  constructor(props) {
    super(props);

    // We set the date to yesterday and we subtract 30 days
    const today = new Date();
    const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');
    const start = moment(today.setDate(today.getDate() - 30)).format(
      'YYYY-MM-DD',
    );

    this.state = {
      filters: {
        championship: 'ALL',
        period: {end, start},
        league: {nbPlayers: []},
      },
      order: {key: 'percentageTeamBidded', value: 'desc'},
      isFetching: false,
      highlightRefreshBtn: true,
    };
  }

  updateFilters(filter) {
    this.setState({filters: {...this.state.filters, ...filter}});
  }

  notifyRefresh(value) {
    const {highlightRefreshBtn} = this.state;
    this.setState({
      highlightRefreshBtn: value !== undefined ? value : !highlightRefreshBtn,
    });
  }

  selectOrChangeOrder(key) {
    if (key === this.state.order.key)
      this.setState({
        order: {key, value: this.state.order.value === 'asc' ? 'desc' : 'asc'},
      });
    else {
      const newOrder = {key};
      // The switch is necessary for the default sortOrder each orderType
      switch (key) {
        case 'lastname':
          newOrder.value = 'asc';
          break;
        case 'percentageFirstTurn':
          newOrder.value = 'desc';
          break;
        case 'percentageSecondTurn':
          newOrder.value = 'desc';
          break;
        case 'percentageNotBiddedOn':
          newOrder.value = 'desc';
          break;
        case 'averagePrice':
          newOrder.value = 'desc';
          break;
        case 'percentageTeamBidded':
          newOrder.value = 'desc';
          break;
        default:
          newOrder.value = 'asc';
      }
      this.setState({order: newOrder});
    }
  }

  fetchStats() {
    const callBacks = {
      onError: error => {
        this.setState({isFetching: false});
        swal({
          title: `Oops...`,
          type: 'error',
          html:
            `Something went wrong !<br/>${error}<br/>` +
            `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
        });
      },
      onRequest: () => this.setState({isFetching: true}),
      onSuccess: () => {
        this.setState({isFetching: false});
        this.notifyRefresh(false);
      },
    };

    if (!this.state.isFetching) {
      const {period, league} = this.state.filters;
      const payload = {
        endDate: moment(period.end).format('YYYY-MM-DD'),
        startDate: moment(period.start).format('YYYY-MM-DD'),
        divisionSizes: league.nbPlayers,
      };
      this.props.dispatch(fetchStatsPlayersValue(payload, callBacks));
    }
  }

  componentDidMount() {
    this.props.dispatch(getChampionships());
  }

  renderTable() {
    const cols = {
      lastName: 'Nom',
      firstName: 'Firstname',
      percentageFirstTurn: 'Turn 1',
      percentageSecondTurn: 'Turn 2',
      percentageOtherTurn: 'Turn N',
      percentageNotBidOn: 'No Bid',
      averagePrice: 'Average Price (M€)',
      percentageTeamBidOn: '% Bidded',
    };
    const formatValueByCol = {
      averagePrice: v => numeral(v).format('0,0'),
      default: (v, k) =>
        isNumber(v) && k.indexOf('percent') > -1
          ? numeral(v > 1 ? 1 : v).format('0,0 %')
          : v,
    };

    const {order, filters} = this.state;
    const {championship} = filters;
    const {data} = this.props;

    let players = {};
    if (championship === 'ALL') {
      Object.values(data).forEach(c =>
        c.forEach(p => {
          if (!players[p.id]) players[p.id] = p;
        }),
      );
    } else {
      players = {};
      if (data[getChampionshipId(championship)]) {
        data[getChampionshipId(championship)].forEach(p => (players[p.id] = p));
      }
    }

    return isEmpty(players) ? (
      <p className="text-center px-3 pb-3">No players to show</p>
    ) : (
      <div className="table-responsive table-fixed-height">
        <table className="table table-striped">
          <thead>
            <tr>
              {map(cols, (value, key) => (
                <th key={key}>
                  <span
                    onClick={() => this.selectOrChangeOrder(key)}
                    className={classNames('orderBtn', {
                      'text-primary': order.key === key,
                    })}>
                    {value}&nbsp;
                    <i
                      className={classNames('fa', {
                        'fa-sort': order.key !== key,
                        [`fa-sort-${order.value}`]: order.key === key,
                      })}
                    />
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {orderBy(players, [order.key], [order.value]).map(player => (
              <tr key={player.id}>
                {map(cols, (value, key) => (
                  <td key={`p-${player.id}-${key}`}>
                    {formatValueByCol[formatValueByCol[key] ? key : 'default'](
                      player[key],
                      key,
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const {isFetching, highlightRefreshBtn} = this.state;
    const {championships} = this.props;
    if (isEmpty(championships)) {
      return <></>;
    }

    return (
      <div id="stats-players-value-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-gavel" />
              {` Players bids and quotations`}
            </h3>
          </div>
          <div className="box-body">
            <div className="margin-bottom">
              <Filters>
                <FilterLocation
                  label="Championship:"
                  availableButtons={getAvailableFlagsButtons(
                    this.props.championships,
                  )}
                  onChange={championship => this.updateFilters({championship})}
                  initialValue={this.state.filters.championship}
                />
                <FilterLeague
                  label="Leagues:"
                  onChange={league => {
                    this.updateFilters({league});
                    this.notifyRefresh(true);
                  }}
                  initialValues={this.state.filters.league}
                />
                <FilterPeriod
                  label="Date range:"
                  onChange={period => {
                    this.updateFilters({period});
                    this.notifyRefresh(true);
                  }}
                  buttonGroup={{
                    icon: 'fa fa-refresh',
                    type: highlightRefreshBtn ? 'success' : 'default',
                    onClick: this.fetchStats.bind(this),
                  }}
                  initialValues={this.state.filters.period}
                />
              </Filters>
            </div>
          </div>
          {isFetching && <Loader />}
          {this.renderTable()}
        </div>
      </div>
    );
  }
}

export default connect(
  state => {
    const {statistics, championships} = state.app;
    return {
      data: statistics.players.value,
      championships: championships.list.data,
    };
  },
  dispatch => ({dispatch}),
)(StatsPlayersValueWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/Players/Value/index.js